@file:OptIn(InternalResourceApi::class)

package flagpack_compose.sample.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String =
    "composeResources/flagpack_compose.sample.shared.generated.resources/"

internal val Res.drawable.flagpack: DrawableResource by lazy {
      DrawableResource("drawable:flagpack", setOf(
        ResourceItem(setOf(), "${MD}drawable/flagpack.png", -1, -1),
      ))
    }

internal val Res.drawable.flagpack_removebg: DrawableResource by lazy {
      DrawableResource("drawable:flagpack_removebg", setOf(
        ResourceItem(setOf(), "${MD}drawable/flagpack_removebg.png", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("flagpack", Res.drawable.flagpack)
  map.put("flagpack_removebg", Res.drawable.flagpack_removebg)
}
